import React, { useRef, useState } from "react";
import { Send, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterForm = ({ source, tags = [], idPrefix = "nl" }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");
  const tsRef = useRef(Date.now());

  const submit = async (e) => {
    e.preventDefault();
    if (state === "sending") return;
    setState("sending");
    try {
      const res = await fetch(`${API}/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, source, tags, consent: true, hp: "", ts: tsRef.current }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data.ok) {
        setState("done");
        if (typeof window.gtag === "function") window.gtag("event", "newsletter_signup", { source });
      } else {
        setState("error");
      }
    } catch (err) {
      setState("error");
    }
  };

  if (state === "done") {
    return (
      <div className="flex items-start gap-2.5 min-h-[46px]" data-testid={`${idPrefix}-success`} role="status">
        <CheckCircle2 size={17} className="text-[#9D0423] mt-0.5 shrink-0" />
        <p className="text-[13px] text-neutral-300 leading-relaxed">
          Almost in — check your inbox and click the confirmation link to start getting The Grit Report.
        </p>
      </div>
    );
  }

  return (
    <form method="post" action={`${API}/subscribe`} onSubmit={submit} className="min-h-[46px]">
      <div className="flex gap-2">
        <label htmlFor={`${idPrefix}-email`} className="sr-only">Email address</label>
        <input
          id={`${idPrefix}-email`}
          type="email"
          name="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          data-testid={`${idPrefix}-email`}
          className="flex-1 min-w-0 bg-[#0D0D0F] border border-white/10 focus:border-[#9D0423] focus:outline-none focus:ring-1 focus:ring-[#9D0423]/40 text-white placeholder:text-neutral-600 px-4 py-3 text-sm transition-colors"
        />
        <input type="text" name="hp" tabIndex={-1} autoComplete="off" aria-hidden="true" defaultValue="" className="absolute -left-[9999px] w-px h-px opacity-0" />
        <input type="hidden" name="source" value={source} readOnly />
        <input type="hidden" name="consent" value="true" readOnly />
        <input type="hidden" name="ts" value={tsRef.current} readOnly />
        <button
          type="submit"
          disabled={state === "sending"}
          data-testid={`${idPrefix}-submit`}
          className="inline-flex items-center gap-2 bg-[#9D0423] hover:bg-[#7E031C] disabled:opacity-60 text-white font-mono font-semibold text-[12px] uppercase tracking-[0.14em] px-5 py-3 transition-colors shrink-0"
        >
          {state === "sending" ? "Sending…" : (<>Subscribe <Send size={13} /></>)}
        </button>
      </div>
      {state === "error" && (
        <p className="mt-2 text-[12px] text-[#E56A79]" data-testid={`${idPrefix}-error`}>
          Couldn't subscribe — please check the email and try again.
        </p>
      )}
    </form>
  );
};
